@if (forgotPasswordForm$ | async; as form) {
  <form
    [ngrxFormState]="form"
    (submit)="onSubmit(form)"
    >
    <div>
      <h5 class="text-muted fw-normal mb-4">
        Password dimenticata? Inserisci la tua email.
      </h5>
      <div>
        <ideapa-text-field
          [label]="'Email'"
          [ngrxFormControlState]="form.controls.username"
          [errors]="form.controls.username.errors | ngrxFormsErr"
          [shouldShowError]="form.controls.username.isInvalid && form.controls.username.isSubmitted"
          >
        </ideapa-text-field>
      </div>
    </div>
    @if (!(resetPasswordEmailSent$ | ngrxPush)) {
      <div class="mt-3 text-end">
        <ideapa-button
          type="submit"
          [cssClasses]="'btn-primary'"
          [text]="'Inviami le istruzioni'"
        ></ideapa-button>
      </div>
    }
  </form>
}

@if ((resetPasswordEmailSent$ | ngrxPush)) {
  <div
    class="login-info text-success text-end mt-3"
    >
    Controlla la tua email per resettare la tua password
  </div>
}
